<template>

<div class="bigtitle">

    <div class="bigtitle-inner inner">

        <h1 v-if="item.titletype === 1 || !item.titletype">{{ item.title }}</h1>
        <h2 v-if="item.titletype === 2">{{ item.title }}</h2>
        <h3 v-if="item.titletype === 3">{{ item.title }}</h3>

    </div>

</div>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

.is-mobile .bigtitle {
    padding: 0px 10px;
}

.bigtitle h1 {
    font-weight: 700;
    font-size: 44px;
    line-height: 50px;
    color: #00583D;
    text-transform: uppercase;
    font-family: "Montserrat", sans-serif;
    margin-bottom: 30px;
}

.is-tablet .bigtitle h1 {
    font-size: 36px;
    line-height: 42px;
}

.is-mobile .bigtitle h1 {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 15px;
}

.bigtitle h2 {
    font-weight: 400;
    font-size: 35px;
    line-height: 40px;
    color: #00583D;
    font-family: "Montserrat", sans-serif;
    margin-bottom: 30px;
}

.is-tablet .bigtitle h2 {
    font-size: 32px;
    line-height: 36px;
}

.is-mobile .bigtitle h2 {
    font-size: 28px;
    line-height: 32px;
    margin-bottom: 15px;
}

.bigtitle h3 {
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
    color: #00583D;
    font-family: "Montserrat", sans-serif;
    margin-bottom: 20px;
}

.is-tablet .bigtitle h3 {
    font-size: 22px;
    line-height: 30px;
}

.is-mobile .bigtitle h3 {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 15px;
}

</style>
